export const getMDAEmailFromParams = (paramsString: string | null | undefined): string | null => {
  // if query param is not the correct format, return early and don't try to fetch producer info
  if (!paramsString?.includes('p=')) return null;

  // Escape '+' before parsing so URLSearchParams doesn't treat it as a space
  const params = new URLSearchParams(paramsString.replace(/\+/g, '%2B'));
  const email = params.get('p');

  if (!email) return null;

  // encode email addresses so emails with special characters can be used and interpreted by the API correctly
  return encodeURIComponent(email);
};
